import { createContext, useContext } from 'react';
import noop from 'lodash/noop';

export const defaultValue = { setLayoutState: noop, resetLayoutState: noop };

export const LayoutContext = createContext(defaultValue);

export default {
    LayoutContext,
};
export const useLayoutContext = () => useContext(LayoutContext);
